import React from "react";
import { Splide, SplideSlide, SplideTrack } from "@splidejs/react-splide";
import "@splidejs/react-splide/css";
import { Image } from "@arctheme-components/elements/Image/Image";
import Paragraph from "@arctheme-components/elements/Paragraph/Paragraph";
import useMobileBreakpoint from '@arctheme-hooks/useMobileBreakpoint';


export const TelcoRecommended = ({ settings }) => {
  // Extract all data from settings
  const { heading, container_type } = settings.settings.section;
  const section = settings.settings.section || {};
  const items = settings.settings.items || [];
  const isMobile = useMobileBreakpoint(settings.settings.mobile_breakpoint || '1024px');
  
  const carouselOptions = {
    type: "loop",
    padding: { right: 30 },
    arrows: false,
    pagination: false,
    perPage: 3,
    drag: true,
    interval: 4000,
    gap: "6px",
    width: "100%",
    cover: true,
    rewind: true,
    breakpoints: {
      768: {
        perPage: 1,
        gap: "4px",
        padding: { right: 33 },
      }
    }
  };

  if (!items.length) {
    return null;
  }

  return (
    <div className={`telco-recommended flex flex-col ${container_type} gap-8 lg:gap-12`}>
      <div className="flex flex-col gap-3 lg:flex-row lg:gap-0 lg:justify-between items-normal lg:items-center">
        <h4 className="h4">{heading}</h4>

        <a href={`/blogs/telco?view=telco-blog`} className="flex gap-3 items-center px-0 py-3 lg:px-6">
            <span className="b_a1">View All</span>
            <div className="w-6 h-6">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path d="M11.293 17.293L12.707 18.707L19.414 12L12.707 5.29297L11.293 6.70697L15.586 11H6V13H15.586L11.293 17.293Z" fill="black"/>
              </svg>
            </div>
        </a>
      </div>
      <div
        style={{
          marginRight: isMobile ? `-${section.padding_right_mobile}px` : `-${section.padding_right_desktop}px`
        }}
      >
        <Splide
          options={carouselOptions}
          hasTrack={false}
          className="main-carousel"
        >
          <SplideTrack>
            {items.map((item, index) => {
              // Extract all fields at once using reduce for better performance
              return (
                <SplideSlide key={index} className="">
                  <div className="relative bg-black/40 rounded overflow-hidden">
                    <Image
                      imageUrl={item.image}
                      alt={item.title}
                      classes="w-full h-full rounded"
                    />
                    <div className="absolute bottom-0 w-full h-80" style={{
                      background: 'linear-gradient(180deg, rgba(30, 30, 30, 0) 0%, #1E1E1E 100%)'
                    }}
                    ></div>
                    <div className="absolute bottom-0 left-0 flex flex-col p-4 lg:p-5">
                      <a href={`/pages/telcos/${item.handle}`} className="flex flex-col gap-5">
                        <div className="flex flex-col gap-2.5">
                          <h6 className={`${isMobile ? 'b_regular_normal' : 'b_large_normal'} text-white !font-normal`}>{item.title}</h6>
                          {item.description && (
                            <Paragraph classes={`${isMobile ? 'b_tiny_normal text-white' : 'b_regular_light text-white'}`} text={item.description} maxChars={0}/>
                          )}
                        </div>
                        <div className="flex justify-between items-center">
                            <span className={`${isMobile ? 'b_a2' : 'b_a1'} text-white`}>Read More</span>
                            <div className="w-3 h-2.5 lg:w-[17px] lg:h-3.5">
                              <svg xmlns="http://www.w3.org/2000/svg" width="auto" height="auto" viewBox="0 0 19 17" fill="none">
                                <path d="M11.2703 0.667236L18.0178 8.00785M18.0178 8.00785L11.2703 15.3485M18.0178 8.00785L0.667236 8.00785" stroke="white" stroke-width="1.33466" stroke-linecap="round" stroke-linejoin="round"/>
                              </svg>
                            </div>
                        </div>
                      </a>
                    </div>
                  </div>
                </SplideSlide>
              );
            })}
          </SplideTrack>
        </Splide>
      </div>
    </div>
  );
};

export default TelcoRecommended;
